/**
 * This is a workaround to expose sn-custom-create-element in a similar fashion as
 * the other legacy global variables exposed (sn-seismic-addons.js, sn-seismic-post-message.js, etc)
 * in order to allow the server-side UMD bundle creation logic to serve ui-mega within a larger
 * bundle.
 * Please rip this out when there is a solution in place to remove the other referenced shims.
 */
import customCreateElement from 'sn-custom-create-element';

if (typeof window !== 'undefined')
	window.__TECTONIC__sn_custom_create_element = customCreateElement;

export default {
	default: customCreateElement,
	__esModule: true
};
